import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';
import {pluralize} from 'common/util/string';

export const popoverBody = ({
  isAggregate,
  retainedCount,
  dataGroupName,
  dataGroupNamePlural,
  retainedPercent,
  dropOffCount,
  dropOffPercent,
}: {
  isAggregate: boolean;
  retainedCount: string;
  dataGroupName: string;
  dataGroupNamePlural: string;
  retainedPercent: string;
  dropOffCount: string;
  dropOffPercent: string;
}) => (
  <>
    <div sel='.popover-content-wrapper'>
      <div sel='.popover-slot'>
        <div sel='.popover-icon.converted-icon'>
          <SvgIconEl attrs={{icon: `community`}} />
        </div>
        <div sel='.popover-content.count'>
          <span sel='.bold'>{retainedCount}</span>
          <span>
            {` `}
            retained{` `}
            {isAggregate ? `(average)` : pluralize(dataGroupName, parseInt(retainedCount), dataGroupNamePlural)}
          </span>
        </div>
        <div sel='.percentage'>
          <span sel='.bold'>{retainedPercent}</span>
        </div>
      </div>
      <div sel='.popover-slot'>
        <div sel='.popover-icon.drop-off-icon'>
          <SvgIconEl attrs={{icon: `circle-decrease`}} />
        </div>
        <div sel='.popover-content.drop_off_count'>
          <span sel='.bold'>{dropOffCount}</span>
          <span>
            {` `}
            dropped {isAggregate ? `(average)` : pluralize(dataGroupName, parseInt(dropOffCount), dataGroupNamePlural)}
          </span>
        </div>
        <div sel='.drop_off_percentage'>
          <span sel='.bold'>{dropOffPercent}</span>
        </div>
      </div>
    </div>
  </>
);
